import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { SystemColor, SystemColorType } from 'icreate/common/models/system-color';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SystemColorService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId: string): Promise<SystemColor[]> {
        return await lastValueFrom(
            this.http.get<SystemColor[]>(`${this.domain}/api/system-color`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getByType(vesselId: string, type: SystemColorType): Promise<SystemColor[]> {
        return await lastValueFrom(
            this.http.get<SystemColor[]>(`${this.domain}/api/system-color/${type}`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(systemColorData) {
        return await lastValueFrom(
            this.http.post<SystemColor>(`${this.domain}/api/system-color`, systemColorData, {
                headers: this.headers,
            })
        );
    }

    async createMultiple(systemColorDataList) {
        return await lastValueFrom(
            this.http.post<SystemColor>(`${this.domain}/api/system-colors`, systemColorDataList, {
                headers: this.headers,
            })
        );
    }

    async update(systemColorData) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/system-color/${systemColorData.id}`, systemColorData, {
                headers: this.headers,
            })
        );
    }

    async delete(systemColorId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/system-color/${systemColorId}`));
    }
}
